import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import MUIToolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import LanguageSelect from '../../LanguageSelect';
import ActionMenu from './ActionMenu/ActionMenu';
import SearchBox from './SearchBox';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  title: {
    flexGrow: 0
  },
  titleInfo: {
    lineHeight: 1
  },
  flex: {
    flexGrow: 1
  }
}));

const Toolbar = ({
  title,
  actions = [],
  marketLanguage,
  showLanguageSelector = true,
  showSearch = true,
  data,
  visible,
  showOnlySearch = false
}) => {
  const classes = useStyles();

  if (!visible) {
    return null;
  }

  let noObjectsTextId;
  switch (data.length) {
    case 0:
      noObjectsTextId = 'table.objectCountNoneLabel';
      break;
    case 1:
      noObjectsTextId = 'table.objectCountOneLabel';
      break;
    default:
      noObjectsTextId = 'table.objectCountPluralLabel';
      break;
  }

  return (
    <MUIToolbar
      className={classes.root}
      style={showOnlySearch ? { justifyContent: 'center' } : {}}
      data-testid="table-toolbar"
    >
      {showOnlySearch ? (
        <SearchBox visible={showSearch} globalSearch />
      ) : (
        <>
          <div className={classes.title} data-testid="table-toolbar-title">
            <Typography variant="h6">
              {title && <FormattedMessage id={title} />}
            </Typography>
            <Typography variant="overline" className={classes.titleInfo}>
              <b>{data.length}</b> <FormattedMessage id={noObjectsTextId} />
            </Typography>
          </div>
          <div className={classes.flex} />
          <LanguageSelect
            visible={showLanguageSelector}
            marketLanguage={marketLanguage}
          />
          <SearchBox visible={showSearch} />
          <ActionMenu actions={actions} />
        </>
      )}
    </MUIToolbar>
  );
};

Toolbar.propTypes = {
  title: PropTypes.string
};

export default Toolbar;
